// Sidebar sections and navigation config
export const SIDEBAR_SECTIONS = [
  {
    id: 'overview', label: 'Overview', icon: '?',
    items: [
      { id: 'wells_summary', label: 'Wells Summary' },
      { id: 'dash', label: 'NPT Summary' },
      { id: 'cost_performance', label: 'Cost & Performance Summary' },
      { id: 'lessons', label: 'Lessons Learned' },
    ],
  },
];


export const LEAF_NAV_MAP: Record<string, { section: string; subTab: string }> = {
  wells_summary: { section: 'overview', subTab: 'wells_summary' },
  dash: { section: 'overview', subTab: 'dashboard' },
  cost_performance: { section: 'cost', subTab: 'cost_performance' },
  lessons: { section: 'lessons', subTab: 'lessons' },
};




